import { isPrerender } from 'shared/seo/prerender'

/**
 * Регистрация service worker (PWA + push).
 *
 * SW активен ТОЛЬКО в production-build (`npm run build`).  В dev-режиме
 * (`react-scripts start`) бандл подаётся без хешей и HMR ходит по
 * собственным эндпоинтам — кешированные через SW чанки ломают
 * горячую перезагрузку.
 *
 * Для тестирования прод-сборки локально: `npm run build && npx serve -s build`
 * — NODE_ENV там будет 'production', SW зарегистрируется.
 */
export function registerServiceWorker(): void {
    if (typeof window === 'undefined') return
    // Сборщик готового HTML (scripts/prerender.js) — SW там не нужен: на
    // localhost он самоудаляется и перезагружает страницу посреди снимка.
    if (isPrerender()) return
    if (!('serviceWorker' in navigator)) return
    if (process.env.NODE_ENV !== 'production') return

    const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href)
    if (publicUrl.origin !== window.location.origin) return

    window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`
        navigator.serviceWorker
            .register(swUrl)
            .then(reg => {
                reg.onupdatefound = () => {
                    const installing = reg.installing
                    if (!installing) return
                    installing.onstatechange = () => {
                        if (installing.state === 'installed') {
                            if (navigator.serviceWorker.controller) {
                                // Новая версия SW готова — клиенту нужен reload.
                                console.info(
                                    '[SW] New content available — refresh.'
                                )
                            } else {
                                console.info('[SW] Content cached for offline.')
                            }
                        }
                    }
                }
            })
            .catch(err => {
                console.error('[SW] Registration failed:', err)
            })
    })
}

export function unregisterServiceWorker(): void {
    if (typeof window === 'undefined') return
    if (!('serviceWorker' in navigator)) return
    navigator.serviceWorker.ready
        .then(reg => reg.unregister())
        .catch(err => console.error(err))
}
